import {
  createNewVehiculeCheckEmail,
  getAllVehiculeCheckEmails,
  getEmailById,
} from '@/api/vehicule-check-email/vehicule-check-email';
import { TVehiculeCheckEmailSchema } from '@/schemas/vehicule-check-email/vehicule-check-email.schema';
import { TCustomQueryProps } from '@/type/hooks.types';
import { ErrorResponse } from '@/utils/axios.http';
import { NOTIFY } from '@/utils/constant.utils';
import { notify } from '@/utils/toast.utils';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const useCreateVehiculeCheckEmail = ({
  t,
  handleSuccess,
}: Partial<TCustomQueryProps> = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: TVehiculeCheckEmailSchema) =>
      createNewVehiculeCheckEmail(data),
    onSuccess: (_, variables) => {
      const { vehiculeCheckId } = variables;

      queryClient.invalidateQueries({ queryKey: ['getAllVehiculeChecks'] });
      queryClient.invalidateQueries({
        queryKey: ['getVehiculeCheckById', vehiculeCheckId],
      });
      queryClient.invalidateQueries({
        queryKey: ['getAllVehiculeCheckEmails'],
      });

      notify(t('inspectionSentSuccessfully'), NOTIFY.SUCCESS);

      handleSuccess?.();
    },
    onError: (error: ErrorResponse) => {
      notify(t('common:errorOccurredTryAgainLater'), NOTIFY.ERROR);
      console.error(error.error);
    },
  });
};

export const useGetAllVehiculeCheckEmails = (
  filter: string,
  page: number,
  limit: number,
) => {
  return useQuery({
    queryKey: ['getAllVehiculeCheckEmails', filter, page],
    queryFn: () => getAllVehiculeCheckEmails(filter, page, limit),
  });
};

export const useGetEmailById = (id: string) => {
  return useQuery({
    queryKey: ['getEmailById', id],
    queryFn: () => getEmailById(id),
    enabled: !!id,
  });
};
